import { render, staticRenderFns } from "./ExpertList.vue?vue&type=template&id=3fac10c7&scoped=true"
import script from "./ExpertList.vue?vue&type=script&lang=js"
export * from "./ExpertList.vue?vue&type=script&lang=js"
import style0 from "./ExpertList.vue?vue&type=style&index=0&id=3fac10c7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fac10c7",
  null
  
)

export default component.exports